import { render, staticRenderFns } from "./setRemark.vue?vue&type=template&id=0f7d4466&scoped=true&"
import script from "./setRemark.vue?vue&type=script&lang=js&"
export * from "./setRemark.vue?vue&type=script&lang=js&"
import style0 from "./setRemark.vue?vue&type=style&index=0&id=0f7d4466&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f7d4466",
  null
  
)

export default component.exports